<template>
    <div>
        <b-button @click="() => {
            this.$router.go(-1);

        }">
            กลับ
        </b-button>

        <b-card-code title="แผนที่">

            <l-map :zoom="zoom" :center="mapCenter" style="height: 100vh;">
                <l-tile-layer :url="url" />
                <!-- วน marker จาก props -->
                <l-marker v-for="(pos, index) in markers" :key="index" :lat-lng.sync="pos.gps">
                    <l-popup>
                        {{ pos.firstname }}

                    </l-popup>
                </l-marker>
            </l-map>
        </b-card-code>
    </div>

</template>
<script>
import store from "@/store/index";

import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'



delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        BCardCode,
    },

    props: {
        // รองรับทั้ง string เดียว หรือหลายจุด
        latlon: {
            type: [String, Array],

        },
    },
    data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 11,
            mapCenter: [14.8924654, 101.7206087],
            markers: []
        }
    },

    async mounted() {
        this.$nextTick(async () => {
            const cleanData = await JSON.parse(JSON.stringify(store.getters.getMapall[0]))
            console.log(cleanData)
            const dd = await cleanData.filter(item => item != null)
            this.markers = await dd.map((el) => {
                console.log(typeof (el))
                if (el) {
                    return {
                        ...el,
                        gps: {
                            lat: JSON.parse(JSON.stringify(el.location.latitude)),
                            lng: JSON.parse(JSON.stringify(el.location.longitude)),
                        },
                    }
                }
            })
            this.mapCenter = this.markers[0].gps
            console.log(this.markers)
        });

    },


}
</script>
